/*
 * Dynamically enriches the CollectionPage JSON-LD with the
 * mainEntity ItemList of products on a PLP.
 */
document.addEventListener("algolia.instantSearch.onRender", function () {
  const scriptEl = document.getElementById("fp-collection-page-schema");
  if (!scriptEl) {
    return;
  }

  const lastResults = window.algoliaShopify?.instantsearch?.search?.helper?.lastResults;
  const hits = lastResults?.hits || [];
  if (hits.length === 0) {
    return;
  }

  let collectionPage;
  try {
    collectionPage = JSON.parse(scriptEl.textContent);
  } catch (e) {
    return;
  }

  const page = lastResults?.page ?? 0;
  const hitsPerPage = lastResults?.hitsPerPage ?? hits.length;
  const positionOffset = page * hitsPerPage;
  const currency = window.algoliaShopify.helpers.activeCurrencyCode();

  collectionPage.mainEntity = {
    "@type": "ItemList",
    numberOfItems: lastResults?.nbHits ?? hits.length,
    url: `${window.location.origin}${window.location.pathname}`,
    itemListElement: hits.map((hit, i) => {
      const productUrl = `${window.location.origin}/products/${hit.handle}`;
      const offers = {
        "@type": "Offer",
        priceCurrency: `${currency.toUpperCase()}`,
        price: `${hit.price}`,
        availability: "https://schema.org/InStock",
        url: productUrl,
      };
      return {
        "@type": "ListItem",
        position: positionOffset + i + 1,
        item: {
          "@type": "Product",
          name: `${hit.title}`,
          url: productUrl,
          image: `${hit.image}`,
          sku: `${hit.sku}`,
          brand: {
            "@type": "Brand",
            name: `${hit.vendor}`,
          },
          ...(hit.inventory_quantity > 0 ? { offers: offers } : {}),
        },
      };
    }),
  };

  scriptEl.textContent = JSON.stringify(collectionPage);
});
